import { Divider, Flex, IconButton, Space, Tooltip } from '@billy/design-system'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { InvoiceLineType } from '@features/invoices/enums/invoiceLineType'

import { InvoiceLineFields } from './elements/InvoiceLineFields'

interface InvoiceLineProps {
  id: string
  index: number
  isRemovable?: boolean
  lineType: InvoiceLineType
  onRemove: () => void
}

export const InvoiceLine = ({ index, isRemovable = true, lineType, onRemove }: InvoiceLineProps) => {
  const { t } = useTranslation()

  const handleRemoveButtonClick = useCallback(() => {
    onRemove()
  }, [onRemove])

  return (
    <>
      <Divider />
      <Space size="s8" />
      <Flex alignContent="center">
        <InvoiceLineFields lineIndex={index} lineType={lineType} />
        <Space horizontal size="s8" />
        {!isRemovable ? (
          <Space horizontal size="s40" /> /* accounts for the remove button */
        ) : (
          <Tooltip label={t('remove')} placement="top">
            <IconButton disabled={!isRemovable} icon="trash" onClick={handleRemoveButtonClick} size="md" />
          </Tooltip>
        )}
      </Flex>
    </>
  )
}
